import React from 'react';
import PropTypes from 'prop-types';


const Search = ({ t, search, placeholder, cssClass, value }) => (
  <React.Fragment>
    <div className="searchbox boxs">
      <img src="/img/search.svg" alt="search" />
      <input
        type="text"
        className={cssClass || 'form-control'}
        placeholder={placeholder || t('Search')}
        onChange={search}
        value={value}
      />
    </div>
  </React.Fragment>
);

Search.propTypes = {
  t: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
};

export default Search;



// WEBPACK FOOTER //
// ./src/components/searchField/Search.jsx